import { render, staticRenderFns } from "./NewSingleCompete.vue?vue&type=template&id=19d790dc&scoped=true&"
import script from "./NewSingleCompete.vue?vue&type=script&lang=js&"
export * from "./NewSingleCompete.vue?vue&type=script&lang=js&"
import style0 from "./NewSingleCompete.vue?vue&type=style&index=0&id=19d790dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d790dc",
  null
  
)

export default component.exports